import React, { Fragment, useEffect, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  loadFromLocalStorage,
  saveToLocalStorage,
} from "../../../utils/LocalStorageUtils";
import {
  apiCall,
  failedMessage,
  setDefaultHeader,
  successMessage,
} from "../../../utils/httpClient";
import { Button, Card, CloseButton, Container, Spinner } from "react-bootstrap";
import { CardBody, Modal, ModalHeader } from "reactstrap";
import { isEmpty } from "../../../utils/utils";
import LoginCover from '../logincover.png';
import "../auth.css";
import { FaApple, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

function SignupDetail() {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  const signupToken = loadFromLocalStorage("SIGNUPTOKEN");
  const signupMobile = loadFromLocalStorage("SIGNUPMOBILE");
  useEffect(() => {
    // Parse the query parameters
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get('token');
    setToken(tokenFromUrl);
  }, [location]);
  useEffect(() => {
    if (authData?.token) {
      return <Navigate to="/" />;
    }
  }, [])

  const validationFormMobile = () => {
    let isError = true;
    let errorMessage = {};
    if (email === undefined || email === "") {
      isError = false;
      errorMessage["email"] = "Please Enter Email ID";
    } else if (isEmpty(token) && !isEmpty(signupToken) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      isError = false;
      errorMessage["email"] = "Invalid email address";
    }
    if (userName === undefined || userName === "") {
      isError = false;
      errorMessage["userName"] = "Please Enter User Name";
    }
    setErrorMessage(errorMessage);
    return isError;
  }
  const validationFormEmail = () => {
    let isError = true;
    let errorMessage = {};
    if (userName === undefined || userName === "") {
      isError = false;
      errorMessage["userName"] = "Please Enter User Name";
    }
    if (mobile === undefined || mobile === "") {
      isError = false;
      errorMessage["mobile"] = "Please Enter Mobile";
    }
    if (password === undefined || password === "") {
      isError = false;
      errorMessage["password"] = "Please Enter Password";
    }
    if (cPassword === undefined || cPassword === "") {
      isError = false;
      errorMessage["cPassword"] = "Please Enter cPassword";
    }
    if (cPassword !== password) {
      isError = false;
      errorMessage["cPassword"] = "Retype Password not match!";
    }
    setErrorMessage(errorMessage);
    return isError;
  }
  const validation = () => {
    if (isEmpty(token)) {
      return validationFormMobile()
    }
    if (!isEmpty(token)) {
      return validationFormEmail()
    }
  };

  const handleSubmitDetail = async () => {
    if (validation()) {
      setLoading(true);
      let params = {};
      let header = {}
      let url = ''
      if (isEmpty(token)) { // for mobile register
        header.token = signupToken
        url = apiEndPoint.SIGNUPFORMOBILE
        params['user_name'] = userName
        params['email'] = email
        params['mobile'] = signupMobile
      } else { // for email register
        header.token = token
        url = apiEndPoint.VERIFYEMAILSIGNUP

        params['mobile'] = mobile;
        params['user_name'] = userName;
        params['password'] = password;
        params['user_type'] = "user";
      }

      const { data } = await apiCall("post", url, params, header);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message);
        setDefaultHeader("token", data.data.token);
        saveToLocalStorage("AUTH_DATA", data.data);
        navigate("/");
      }
      setLoading(false);
    }
  };
  

  return (
    <Fragment>
      <Container>
        <section className="log-in-section">
          <div className="login-bg">
            <div className="">
              <img
                src="/assets/images/fulllogo.png"
                alt="" width={200}
              />
            </div>
            <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-4 my-col-2">
                <div className="lt-text">
                  <h3>Create an account</h3>
                  <p>
                    Get access to our wide variety of templates and start your
                    digital journey today!
                  </p>
                </div>
                <form>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Your name</label>
                          <input
                            htmlFor="email"
                            value={userName}
                            type="name"
                            size="large"
                            onChange={(e) => setUserName(e.target.value)}
                            placeholder={"User name"}
                            className={`${errorMessage.userName ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.userName && (
                            <span className="er-msg-show">
                              {errorMessage.userName}
                            </span>
                          )}
                        </div>
                      </div>
                      {isEmpty(token) ?
                        <div className="col-lg-12 mt-adj">
                          <div className="input-field-box">
                            <label>Email</label>
                            <input
                              type="email"
                              htmlFor="email"
                              value={email}
                              size="large"
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder={"Enter your email"}
                              className={`${errorMessage.email ? "input-errmsg" : ""
                                } form-control`}
                            />
                            {errorMessage.email && (
                              <span className="er-msg-show">
                                {errorMessage.email}
                              </span>
                            )}
                          </div>
                        </div>
                        :
                        <div>
                          <div className="col-lg-12 mt-adj">
                            <div className="input-field-box">
                              <label>Mobile Number</label>
                              <input
                                type="number"
                                htmlFor="password"
                                value={mobile}
                                size="large"
                                onChange={(e) => setMobile(e.target.value)}
                                placeholder={"Enter your mobile"}
                                className={`${errorMessage.mobile ? "input-errmsg" : ""
                                  } form-control`}
                              />
                              {errorMessage.mobile && (
                                <span className="er-msg-show">
                                  {errorMessage.mobile}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mt-adj">
                            <div className="input-field-box">
                              <label>Password</label>
                              <input
                                type="password"
                                htmlFor="password"
                                value={password}
                                size="large"
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={"******"}
                                className={`${errorMessage.password ? "input-errmsg" : ""
                                  } form-control`}
                              />
                              {errorMessage.password && (
                                <span className="er-msg-show">
                                  {errorMessage.password}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mt-adj">
                            <div className="input-field-box">
                              <label>Retype Password</label>
                              <input
                                type="password"
                                htmlFor="password"
                                value={cPassword}
                                size="large"
                                onChange={(e) => setCPassword(e.target.value)}
                                placeholder={"******"}
                                className={`${errorMessage.cPassword ? "input-errmsg" : ""
                                  } form-control`}
                              />
                              {errorMessage.cPassword && (
                                <span className="er-msg-show">
                                  {errorMessage.cPassword}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                      }
                    </div>
                    <br />
                    <div className="sav-btn mt-adj">
                      <button
                        type="button"
                        onClick={() => handleSubmitDetail()}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          "Create my account"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
                <p className="pos-adj mt-4" style={{ color: '#444', fontWeight: 400 }}>
                  By continuing, you agree to our
                  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    Terms and Conditions
                  </a> <span>and</span>  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >Privacy Policy
                  </a>
                </p>
                <p className="pos-adj mt-4" style={{ color: '#444', fontWeight: 400 }}>
                  Already have an account?
                  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Log In
                  </a>
                </p>
              </div>
              <div className="col-lg-8 my-col-1">
                <div className="text-center">
                  <img src={LoginCover} alt="login-vector" className="login-vector" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </Fragment>
  );
}

export default SignupDetail;